/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';

import {
  restructureContestModel,
  restructureContestViewModel
} from './restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

class ContestsService {
  async getContestList(state, queryParams) {
    const response = await api.get('/contests', {
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureContestModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async getContestById(state, id) {
    const response = await api.get(`/contests/${id}`, {
      expand:
        'hideContestsPlaces.hideContestUser.hideUser.hideProfile,hideContestsPlaces.contest_prize,contest_me_state.hideUser.hideProfile'
    });
    const responseJson = await response.json();

    return {
      response: responseJson,
      destructData: _.keyBy(
        _.map([responseJson.data], item =>
          restructureContestViewModel(state, item)
        ),
        'id'
      )
    };
  }

  async sendParticipateContestById(state, id) {
    const response = await api.post(`/contests/${id}/participate`, {}, {});
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new ContestsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/contests/services/ContestsService/ContestsService.js